import { Alert, AppShell } from '@wyz/ui';
import * as React from 'react';
import { useLocation } from 'react-router';
import { Footer, NavbarTop, Sidebar } from '~/common/components';
import { Trans, useDebugContext, usePlugin, useTheme } from '~/common/context';

export default function AppLayout(props: React.PropsWithChildren) {
  const { pathname } = useLocation();
  const isDebugMode = useDebugContext();
  const { navbarPosition } = useTheme();
  const pluginContext = usePlugin();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <AppShell>
      <React.Activity mode={pluginContext.isPluginReady ? 'visible' : 'hidden'}>
        <>
          {pluginContext.enabledPlugins.sidebar ? (
            <custom-sidebar></custom-sidebar>
          ) : (
            <AppShell.Navbar
              visible={
                navbarPosition === 'vertical' || navbarPosition === 'combo'
              }
              toggleButton={<AppShell.ToggleButton />}
            >
              <Sidebar />
            </AppShell.Navbar>
          )}
        </>
      </React.Activity>
      <AppShell.Main>
        {isDebugMode && (
          <div className='p-2'>
            <Alert variant='warning' dismissible>
              <Trans i18nKey='app.common.debug_mode.title' />
            </Alert>
          </div>
        )}

        <React.Activity
          mode={pluginContext.isPluginReady ? 'visible' : 'hidden'}
        >
          <>
            {pluginContext.enabledPlugins.navbar ? (
              <custom-navbar name={'App'}></custom-navbar>
            ) : (
              <AppShell.Header>
                <NavbarTop />
              </AppShell.Header>
            )}
          </>
        </React.Activity>

        {/*------ Main Routes ------*/}
        {props.children}

        <React.Activity
          mode={pluginContext.isPluginReady ? 'visible' : 'hidden'}
        >
          <>
            {pluginContext.enabledPlugins.footer ? (
              <custom-footer></custom-footer>
            ) : (
              <AppShell.Footer>
                <Footer />
              </AppShell.Footer>
            )}
          </>
        </React.Activity>
      </AppShell.Main>
    </AppShell>
  );
}
